// @ts-nocheck
import { IconOffset } from "@toolkit/Framework/Types/Icon";
import * as React from "react";

const ArrowBackward: React.FC = () => {
    return (
        <svg focusable="false" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
            <path
                d="M19 11H7.14l3.63-4.36a1.001 1.001 0 00-1.54-1.28l-5 6a1.19 1.19 0 00-.09.15c0 .05 0 .08-.07.13A1 1 0 004 12a1 1 0 00.07.36c0 .05 0 .08.07.13.026.052.056.102.09.15l5 6A1 1 0 0010 19a1 1 0 00.77-1.64L7.14 13H19a1 1 0 100-2z"
                fill="currentColor"
                fillRule="evenodd"
                clipRule="evenodd"
            />
        </svg>
    );
};

export const ArrowBackwardOffset: IconOffset = {
    vertical: 18,
    horizontal: 16,
};

export default React.memo(ArrowBackward);
